module.exports = __webpack_public_path__ + "assets/ea5ab1080e67b1808e15a2e8b8f63609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/3.png
// module id = 341
// module chunks = 1